import Alpine from "alpinejs";

export interface MiniCartStore {
	numberOfItems: number;
	showAnimation: boolean;
	setItemCount(count: number, triggerAnimation: boolean): void;
}

export const miniCartStore = Alpine.store("cart", {
	numberOfItems: 0,
	showAnimation: false,
	setItemCount(count: number, triggerAnimation: boolean) {
		this.numberOfItems = Math.round(count * 100) / 100;
		this.showAnimation = triggerAnimation;
		if (triggerAnimation) {
			setTimeout(() => (this.showAnimation = false), 1000);
		}
	},
} as MiniCartStore);
